// extracted by mini-css-extract-plugin
module.exports = {"quorum":"quorum_quorum__25MdF","cols":"quorum_cols__3BhN6"};